module.exports = __webpack_public_path__ + "img/logo.b6aa0335.png";